export const SET_LOADING = '@paymentsDetails/SET_LOADING';
export const SAVE_DATA = '@paymentsDetails/SAVE_DATA';



// WEBPACK FOOTER //
// ./src/Modules/PaymentDetails/constants.js